
import * as syncTreeApi from './compatible';

export default syncTreeApi;
